<template>
  <generic-modal :title="$t('order')" ref="generic_modal" :is_wide="true">
    <div class="title is-5 is-pulled-right">
      <div class="has-text-primary has-text-right">
        {{ $t("total") }} {{ format_currency(meta.total) }}
      </div>
      <div class="has-text-warning has-text-right">
        {{ meta.payment_method_title }}
      </div>
    </div>
    <div class="title is-5">{{ $t("order") }} {{ meta.number }}</div>
    <div class="subtitle is-5 mb-5">
      {{ $t("status") }}:
      <span class="has-text-warning" v-if="meta.status">{{
        $t(meta.status)
      }}</span>
    </div>

    <div class="columns mt-5">
      <div class="column is-two-thirds">
        <div v-if="meta && meta.billing">
          <div class="title is-5 mb-2">{{ $t("billing") }}</div>
          <div class="columns">
            <div class="column">
              <div class="title is-6">
                <span class="icon">
                  <i class="fa fa-user"></i>
                </span>
                {{ meta.billing.first_name }} {{ meta.billing.last_name }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-envelope"></i>
                </span>
                {{ meta.billing.email }}
              </div>
              <div class="subtitle is-6">
                <span class="icon">
                  <i class="fa fa-phone"></i>
                </span>
                {{ meta.billing.phone }}
              </div>
            </div>
            <div class="column">
              <div class="title is-6">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.billing.address_1 }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.billing.address_2 }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.billing.city }} - {{ meta.billing.state }}
              </div>
              <div class="subtitle is-6">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.billing.postcode }} - {{ meta.billing.country }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div v-if="meta && meta.shipping">
          <div class="title is-5 mb-2">{{ $t("delivery") }}</div>
          <div class="columns">
            <div class="column">
              <div class="title is-6">
                <span class="icon">
                  <i class="fa fa-user"></i>
                </span>
                {{ meta.shipping.first_name }} {{ meta.shipping.last_name }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-phone"></i>
                </span>
                {{ meta.shipping.phone }}
              </div>
            </div>
            <div class="column">
              <div class="title is-6">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.shipping.address_1 }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.shipping.address_2 }}
              </div>
              <div class="subtitle is-6 mb-0">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.shipping.city }} - {{ meta.shipping.state }}
              </div>
              <div class="subtitle is-6">
                <span class="icon">
                  <i class="fa fa-map-marker"></i>
                </span>
                {{ meta.shipping.postcode }} - {{ meta.shipping.country }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="meta && meta.line_items">
      <div class="title is-5">{{ $t("items") }}</div>
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("price") }}</th>
            <th>{{ $t("total") }}</th>
            <th>{{ $t("status") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in meta.line_items">
            <td>{{ item.name }}</td>
            <td>{{ item.quantity }}</td>
            <td>{{ format_currency(item.price) }}</td>
            <td>{{ format_currency(item.total) }}</td>
            <td>
              <div class="field">
                <div class="control" v-if="item.modul_woocommerce_product">
                  <div class="tags has-addons">
                    <div class="tag">
                      <i class="fa fa-check has-text-primary"></i>
                    </div>
                    <div class="tag">
                      {{ $t("product imported from woocommerce") }}
                    </div>
                  </div>
                </div>
                <div class="control" v-else>
                  <div class="tags has-addons">
                    <div class="tag is-delete has-text-danger"></div>
                    <div class="tag is-warning">
                      {{ $t("product not found, please import it") }}
                    </div>
                  </div>
                </div>
                <div class="control" v-if="item.modul_homologation">
                  <div class="tags has-addons">
                    <div class="tag">
                      <i class="fa fa-check has-text-primary"></i>
                    </div>
                    <div class="tag">
                      {{ $t("homologated to") }}
                      {{ item.modul_homologation.modul_product.name }}
                    </div>
                  </div>
                </div>
                <div class="control" v-else>
                  <div class="tags has-addons">
                    <div class="tag is-delete has-text-danger"></div>
                    <div class="tag is-warning">
                      {{
                        $t("product not homologated yet, please homologate it")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button
        class="button is-rounded"
        :disabled="!is_order_valid"
        @click="process_order"
      >
        <span class="icon">
          <i class="fa fa-cogs"></i>
        </span>
        <span>{{ $t("process order") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "WooCommerceOrderModal",
  components: { GenericModal },
  data() {
    return {
      meta: { settings: {} },
      error: "",
    };
  },
  props: {},
  computed: {
    is_order_valid() {
      let v = this;
      let items = v.meta.line_items || [];
      let invalid = items.find((item) => {
        return !item.modul_woocommerce_product || !item.modul_homologation;
      });
      return !invalid;
    },
  },
  methods: {
    change_active_tab,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/woocommerce/order", { uuid: uuid })
        .then((order) => {
          v.meta = order.json_data;
          v.meta.uuid = uuid;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    update_order() {
      let v = this;
      v.$root.loader(true);
      get("/woocommerce/order/from-server", { uuid: v.meta.uuid })
        .then((order) => {
          v.$emit("order_updated");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    process_order() {
      let v = this;
      v.$emit("process_order", v.meta.uuid);
      v.close_modal();
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
